import React from "react";

interface AguiMessageProps {
  message: {
    text: string;
    category: "broadcast" | "weather" | "lost_found";
    [key: string]: any;
  };
}

const categoryStyles: Record<string, React.CSSProperties> = {
  broadcast: {
    background: "green",
    color: "white",
    borderRadius: 6,
    padding: 8,
    margin: "4px 0",
  },
  weather: {
    background: "red",
    color: "white",
    fontWeight: "bold",
    borderRadius: 6,
    padding: 8,
    margin: "4px 0",
  },
  lost_found: {
    background: "yellow",
    color: "black",
    borderRadius: 6,
    padding: 8,
    margin: "4px 0",
  },
};

export const AguiMessage: React.FC<AguiMessageProps> = ({ message }) => {
  const style = categoryStyles[message.category] || {};
  return (
    <div style={style}>
      {message.text}
    </div>
  );
};

export default AguiMessage; 